import { atomWithStorage } from "jotai/utils";

export const toolTitleAtom = atomWithStorage("toolTitle");
